import { getCookieData } from "@crystal/core";
function isAuthNSession() {
  const sessionInfo = getCookieData(SESSION_INFO_COOKIE_NAME);
  return !!sessionInfo;
}
function hasAuthToken() {
  if (isAuthNSession()) {
    return true;
  }
  const { isLoggedin } = getCookieData(AUTH_INFO_COOKIE_NAME) || {};
  return !!isLoggedin;
}
const AUTH_INFO_COOKIE_NAME = "userIsLogged";
const SESSION_INFO_COOKIE_NAME = "account.grant.sessionInfo";
const ACCESS_TOKEN_COOKIE_NAME = "account.grant.accessToken";
const REFRESH_TOKEN_COOKIE_NAME = "account.grant.refreshToken";
const PARTNER_TOKEN_COOKIE_NAME = "partnerToken";
const PARTNER_COOKIE_NAME = "partner";
const PARTNER_COOKIE_CODE = "code";
const PARTNER_COOKIE_STATE = "state";
export {
  ACCESS_TOKEN_COOKIE_NAME,
  AUTH_INFO_COOKIE_NAME,
  PARTNER_COOKIE_CODE,
  PARTNER_COOKIE_NAME,
  PARTNER_COOKIE_STATE,
  PARTNER_TOKEN_COOKIE_NAME,
  REFRESH_TOKEN_COOKIE_NAME,
  SESSION_INFO_COOKIE_NAME,
  hasAuthToken,
  isAuthNSession
};
//# sourceMappingURL=cookie.js.map
